import { CollectionLendCount } from '@/api'
import { Module } from 'nuxt-property-decorator'
import BaseStore from '@/store/BaseStore'

// TODO いらないのかもしれない
type ListLendBooksCountConfirmationItem = {
  startIndex: number
  endIndex: number
  items: CollectionLendCount[]
}

const PER_FETCH_COUNT = 100

@Module({
  name: 'LendBooksCountConfirmationStore',
  namespaced: true,
  stateFactory: true
})
export default class LendBooksCountConfirmationStore extends BaseStore {
  _page: number = 1

  _total: number = 0

  _items: CollectionLendCount[] = []

  get page() {
    return this._page
  }

  get perPage() {
    return PER_FETCH_COUNT
  }
}
